import React, { useContext } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import NumberFormat from 'react-number-format';

import { getBreakPoints } from '../../Hub/HubUtils';
import { determineFundName, determineFundTicker, determineRegistrationGroupingDisplayName } from '../TransferUtils';
import TransferContext from '../../../containers/TransferContainer/context';
import AutomatedTransferBadge from '../AutomatedTransferBadge/AutomatedTransferBadge';
import './TransferTable.scss';

const TransferTable = ({agreementsGroupByType}) => {

    const { dispatch } = useContext(TransferContext);

    const setActive = (groupIndex, agreementIndex) => {
        dispatch({
            type: 'UPDATE_TRANSFER_AGREEMENTS',
            payload: {
                groupIndex,
                agreementIndex,
            }
        })
    };
    const totalReducer = (prev, curr) => prev + curr;

    return (
      <div>
        {getBreakPoints('sm') ? (
            <table className='transfer-agreements-table'>
            <tr>
                <th>ACCOUNT</th>
                <th>NOTES</th>
                <th>BALANCE*</th>
            </tr>
            {agreementsGroupByType.map((agreementGroup, groupIndex) =>
                agreementGroup.existingAgreement && Object.keys(agreementGroup.existingAgreement).length && agreementGroup.agreements &&
                Object.keys(agreementGroup.agreements).length > 0 ?
                <>
                    <tr>
                        <td colSpan='3' className='transfer-agreement-type-column'>
                            <div className='transfer-agreement-type'>
                                <strong>{determineRegistrationGroupingDisplayName(agreementGroup)}</strong>
                            </div>
                        </td>
                    </tr>
                    {agreementGroup.agreements.map((agreement, agreementIndex) =>
                        <tr>
                            <td>
                                <FormControlLabel
                                    label={
                                        <div className='blocked_data'>
                                            <div className={agreement.isTransfer ? 'transfer-agreement-title-selected' : 'transfer-agreement-title'}>
                                                {determineFundName(agreement, agreementGroup.productTypeId)} {determineFundTicker(agreement, agreementGroup.productTypeId)}
                                            </div>
                                            <div style={{fontSize: '16px'}}>
                                                {agreement.agreementNumber}{agreement.checkSum ? `-${agreement.checkSum}` : null} • {agreementGroup.owners.join(', ')}
                                                {agreementGroup.deceasedOwner && agreementGroup.deceasedOwner.length ? `, ${agreementGroup.deceasedOwner} (DCD)` : ''}
                                                {agreementGroup.powerOfAttorney && agreementGroup.powerOfAttorney.length ? `, ${agreementGroup.powerOfAttorney} (Agent)` : ''}
                                            </div>
                                        </div>
                                    }
                                    control={
                                        <Checkbox
                                            color='secondary'
                                            name={agreement.agreementNumber}
                                            checked={agreement.isTransfer}
                                            onChange={() => setActive(groupIndex, agreementIndex)}
                                        />
                                    }
                                />
                            </td>
                            <td>
                                <AutomatedTransferBadge />
                            </td>
                            <td>
                                <NumberFormat className='blocked_data' style={{ fontSize: '20px', lineHeight: '32px' }} value={agreement.holdings.map(holding => holding.amount)
                                    .reduce(totalReducer).toFixed(2)} displayType='text' thousandSeparator prefix='$' />
                            </td>
                        </tr>
                    )}
                </> : null
            )}
        </table>
          ) :
            (<div>
        {agreementsGroupByType.map((agreementGroup, groupIndex) =>
            agreementGroup.existingAgreement && Object.keys(agreementGroup.existingAgreement).length && agreementGroup.agreements &&
            Object.keys(agreementGroup.agreements).length > 0 ?
            <>
            <div style={{color: 'white', backgroundColor: '#002F48', padding: '8px'}}>
                <strong>{determineRegistrationGroupingDisplayName(agreementGroup)}</strong>
            </div>

            {agreementGroup.agreements.map((agreement, agreementIndex) =>
            <>
            <div>
            <FormControlLabel
                label={
                    <div className='blocked_data'>
                        <div className={agreement.isTransfer ? 'transfer-agreement-title-selected' : 'transfer-agreement-title'}>
                            {determineFundName(agreement, agreementGroup.productTypeId)} {determineFundTicker(agreement, agreementGroup.productTypeId)}
                        </div>
                        <div style={{fontSize: '16px'}}>
                            {agreement.agreementNumber}{agreement.checkSum ? `-${agreement.checkSum}` : null} • {agreementGroup.owners.join(', ')}
                            {agreementGroup.deceasedOwner && agreementGroup.deceasedOwner.length ? `, ${agreementGroup.deceasedOwner} (DCD)` : ''}
                            {agreementGroup.powerOfAttorney && agreementGroup.powerOfAttorney.length ? `, ${agreementGroup.powerOfAttorney} (Agent)` : ''}
                        </div>
                    </div>
                }
                control={
                    <Checkbox
                        color='secondary'
                        name={agreement.agreementNumber}
                        checked={agreement.isTransfer}
                        onChange={() => setActive(groupIndex, agreementIndex)}
                    />
                }
            />
            </div>
            <AutomatedTransferBadge/>
            <div style={{padding: '16px 0 20px 30px'}}>
                <NumberFormat  className='blocked_data' value={agreement.holdings.map(holding => 
                    holding.amount).reduce(totalReducer).toFixed(2)} displayType='text' thousandSeparator prefix='$' />
            </div>
            </> )} </> : null)}

      </div>)
        }
      </div>
    )
};

export default TransferTable;
